import { ACtaBoxMixin } from '../utils/mixins/_a-cta-box';

class ACtaBoxAnchor extends ACtaBoxMixin(HTMLAnchorElement) {}

customElements.define('a-cta-box-anchor', ACtaBoxAnchor, { extends: 'a' });
